// Controls the floating gift hint visibility and progress based on cart total

(() => {
  const HINT_ID = 'gift-hint';
  const COOKIE_NAME = 'gift-hint-dismissed';
  const COOKIE_EXPIRY_DAYS = 7; // Cookie für 7 Tage gültig

  function getHintEl() {
    return document.getElementById(HINT_ID);
  }

  function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/`;
  }

  function getCookie(name) {
    const nameEQ = `${name}=`;
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  function isHintDismissed() {
    return getCookie(COOKIE_NAME) === 'true';
  }

  function dismissHint() {
    setCookie(COOKIE_NAME, 'true', COOKIE_EXPIRY_DAYS);
  }

  async function fetchCart() {
    try {
      const resp = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!resp.ok) throw new Error('Cart fetch failed');
      return await resp.json();
    } catch (e) {
      console.error('[gift-hint] cart fetch error', e);
      return null;
    }
  }

  function isDrawerOpen() {
    const drawer = document.querySelector('cart-drawer');
    return !!(drawer && drawer.classList.contains('active'));
  }

  function setProgress(hint, cartTotalCents) {
    const thresholdCents = Number(hint.dataset.thresholdCents || 0);
    const amountRemainingEl = hint.querySelector('.gift-hint__amount-remaining');
    const barFill = hint.querySelector('.gift-hint__progress-bar-fill');

    if (!thresholdCents || !barFill) return;

    const pct = Math.max(0, Math.min(100, (cartTotalCents * 100.0) / thresholdCents));
    barFill.style.width = `${pct}%`;

    if (amountRemainingEl) {
      const remaining = Math.max(0, thresholdCents - cartTotalCents);
      // Convert cents to localized EUR without currency symbol; rely on theme styles for symbol
      const euros = (remaining / 100).toFixed(2).replace('.', ',');
      amountRemainingEl.textContent = euros + '\u00A0€';
    }
  }

  async function refreshHint() {
    const hint = getHintEl();
    if (!hint) return;

    // Check if hint was dismissed
    if (isHintDismissed()) {
      hint.style.display = 'none';
      return;
    }

    const cart = await fetchCart();
    if (!cart) return;

    const thresholdCents = Number(hint.dataset.thresholdCents || 0);
    const isThresholdReached = cart.total_price >= thresholdCents;

    setProgress(hint, cart.total_price);

    // Only show when drawer is closed, cart has items, and threshold not reached
    const shouldShow = !isDrawerOpen() && cart.item_count > 0 && !isThresholdReached;
    hint.style.display = shouldShow ? '' : 'none';
  }

  function setupClose() {
    const hint = getHintEl();
    if (!hint) return;
    const close = hint.querySelector('.gift-hint__close');
    if (close && !close.dataset.bound) {
      close.dataset.bound = 'true';
      close.addEventListener('click', () => {
        hint.style.display = 'none';
      });
    }
  }

  function setupDrawerObservers() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    const observer = new MutationObserver(() => refreshHint());
    observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  function setupPubSub() {
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, () => refreshHint());
      }
    } catch (_) {
      // no-op
    }
  }

  window.addEventListener('load', () => {
    setupClose();
    setupDrawerObservers();
    setupPubSub();
    refreshHint();
  });
})();
